import type { Prototype } from "../prototype-types";

export const ryanLeePrototypes: Prototype[] = [
  {
    id: "rl-my-shop-story",
    name: "My Shop — Brand Story",
    path: "/rl/my-shop-story",
    description:
      "A faithful rebuild of the Brand Portal My shop \u2192 Brand story editor (/brand-portal/my-shop/story) inside the brand-portal nav shell \u2014 cover & profile image, feature image, logo, brand story, additional images, video, catalog, about your brand, brand practice tags, identity tags, and publications. Baseline for designing additional story modules.",
    owner: "Ryan Lee",
    createdAt: "2026-08-24",
    lastUpdated: "2026-08-24",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-my-shop-story.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-suma-website-link",
    name: "Website adoption and configurator v2",
    path: "/rl/suma-website-link",
    description:
      "A Faire Direct website-adoption flow leading into a configurable wholesale page. Compare channel-editing patterns, brand states, page content, product showcase eligibility, and matched visual styles.",
    owner: "Ryan Lee",
    createdAt: "2026-07-31",
    lastUpdated: "2026-09-15",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-suma-website-link.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-suma-website-link-v2",
    name: "Website Builder V2",
    path: "/rl/suma-website-link-v2",
    description:
      "Fork of Website Builder for a bigger pass on the configurator. Same adoption flow into a configurable wholesale page; the original prototype stays as the reference.",
    owner: "Ryan Lee",
    createdAt: "2026-09-18",
    lastUpdated: "2026-09-18",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-suma-website-link.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-website-builder-system",
    name: "Website Builder — System",
    path: "/rl/website-builder-system",
    description:
      "The main Website Builder system, shown as Suma: Home banner, Faire Direct pitch, and the configurator for a brand's own wholesale page. Every brand prototype is built from this same framework.",
    owner: "Ryan Lee",
    createdAt: "2026-09-27",
    lastUpdated: "2026-09-27",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-website-builder-system.png",
    creationTool: "cursor",
  },
  {
    id: "rl-kendrick-home-website-builder",
    name: "Kendrick Home — Website Builder",
    path: "/rl/kendrick-home-website-builder",
    description:
      "Website Builder for Kendrick Home, who already run an early two-option wholesale page with a hand-built Faire Direct widget: the upgrade banner, and their live wholesale page in their own chrome, editable in the configurator.",
    owner: "Ryan Lee",
    createdAt: "2026-09-27",
    lastUpdated: "2026-09-27",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-kendrick-home-website-builder.png",
    creationTool: "cursor",
  },
  {
    id: "rl-angel-dear-website-builder",
    name: "Angel Dear — Website Builder",
    path: "/rl/angel-dear-website-builder",
    description:
      "Website Builder for Angel Dear, who already embed Faire's full-page widget on their wholesale page: the upgrade banner, and their live wholesale page in their own chrome, editable in the configurator.",
    owner: "Ryan Lee",
    createdAt: "2026-09-27",
    lastUpdated: "2026-09-27",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-angel-dear-website-builder.png",
    creationTool: "cursor",
  },
  {
    id: "rl-toysmith-website-builder",
    name: "Toysmith — Website Builder",
    path: "/rl/toysmith-website-builder",
    description:
      "Le Lis Website Builder forked for Toysmith: their home banner, Faire Direct pitch, and a live wholesale page in their own chrome with their Faire products, collections and reviews, editable in the configurator.",
    owner: "Ryan Lee",
    createdAt: "2026-09-24",
    lastUpdated: "2026-09-24",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-toysmith-website-builder.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-lelis-website-builder",
    name: "Le Lis — Website Builder",
    path: "/rl/lelis-website-builder",
    description:
      "Website Builder V2 forked for Le Lis alone: their home banner, Faire Direct pitch, and a live wholesale page in their own chrome, editable in the configurator. Diverges freely from the shared builder.",
    owner: "Ryan Lee",
    createdAt: "2026-09-23",
    lastUpdated: "2026-09-23",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-lelis-website-builder.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-emily-lex-terms",
    name: "Emily Lex — Brand Terms at Checkout",
    path: "/rl/emily-lex-terms",
    description:
      "A faithful Emily Lex Studio shopping funnel — brand page → product → cart → checkout → order confirmation — with six switchable ways a brand's custom Terms of Service can surface at checkout and on the order confirmation. Toolbar toggles the treatment.",
    owner: "Ryan Lee",
    createdAt: "2026-07-27",
    lastUpdated: "2026-08-10",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-emily-lex-terms.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-public-goods-wholesale",
    name: "Public Goods (Brand Wholesale)",
    path: "/rl/public-goods-wholesale",
    description:
      "Templated brand-wholesale flow, first brand: Public Goods. Reproduced Public Goods (Shopify) site → its wholesale login → handoff into Faire. Toolbar toggles between the modified Faire brand page (logged-in) and Faire sign-up (logged-out). Captured-page harness + brand profile are reusable for more brands.",
    owner: "Ryan Lee",
    createdAt: "2026-06-17",
    lastUpdated: "2026-06-25",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/562fb23476b517d4f25b2dfc0832ea074dbecafbc80c485b10d7b2951248af16.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-font-pressure-testing",
    name: "Brand Refinement — Font pressure testing",
    path: "/rl/font-pressure-testing",
    description:
      "Pressure-testing GT Standard + GT Canon type and refreshed colors, starting with the discover product tile.",
    owner: "Ryan Lee",
    createdAt: "2026-05-30",
    lastUpdated: "2026-06-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/79e1ff5f5418deaaaf456485807ed62a9017c5c1e54c9c27abae18de54c1ed4f.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-damaged-and-missing",
    name: "Damaged and Missing",
    path: "/rl/damaged-and-missing",
    description:
      "Damaged and Missing flow — iterating from Katherine's FBF Support in Messenger as a starting base.",
    owner: "Ryan Lee",
    createdAt: "2026-05-09",
    lastUpdated: "2026-05-09",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail: "/images/thumbnails/rl-damaged-and-missing.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-ora-cacao-connect",
    name: "Customer leads",
    path: "/rl/ora-cacao-connect",
    description:
      "Mobile lead-intake landing for Ora Cacao after a QR/NFC scan. Email + name capture, branded confirmation, then a Faire Direct landing page. Variant picker in the toolbar swaps between 'New to Faire, logged out' (sign-up CTA) and 'Faire retailer, logged out' (sign-in CTA).",
    owner: "Ryan Lee",
    createdAt: "2026-05-06",
    lastUpdated: "2026-05-08",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "mobile",
    thumbnail: "/images/thumbnails/rl-ora-cacao-connect.png",
    creationTool: "claude-code",
  },
  {
    id: "data-demo",
    name: "Data Demo",
    path: "/rl/data-demo",
    description:
      "Live brand page wired to real production brand and product data. Brand variants for Le Bon Shoppe and Aaron Probyn US, plus search variants for socks and protein snacks pulled from production. Includes side cart, sticky filter row, brand carousels, and a ratings & reviews module.",
    owner: "Ryan Lee",
    createdAt: "2026-05-04",
    lastUpdated: "2026-05-05",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "/images/thumbnails/data-demo.png",
    creationTool: "claude-code",
  },
  {
    id: "cart",
    name: "Cart",
    path: "/rl/cart",
    description:
      "1:1 production cart clone as a foundation for Boards tab proposals.",
    owner: "Ryan Lee",
    createdAt: "2026-04-25",
    lastUpdated: "2026-05-01",
    surfaceArea: "Retailer",
    category: "template",
    status: "in-progress",
    thumbnail: "/images/thumbnails/cart.png",
    creationTool: "claude-code",
  },
  {
    id: "sidecart-to-cart",
    name: "Sidecart to Cart",
    path: "/rl/sidecart-to-cart",
    description:
      "Exploring a more intuitive path from sidecart to brand cart. Starting point based on the current v3 brand page experiment.",
    owner: "Ryan Lee",
    createdAt: "2026-04-21",
    lastUpdated: "2026-04-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "/images/thumbnails/sidecart-to-cart.png",
    creationTool: "claude-code",
  },
  {
    id: "brand-page-v3",
    name: "Brand Page V3",
    path: "/rl/brand-v3",
    description:
      "Production-matching brand page with v3 header, sticky tabs, search, and responsive product grid.",
    owner: "Ryan Lee",
    createdAt: "2026-04-26",
    lastUpdated: "2026-04-26",
    surfaceArea: "Retailer",
    category: "template",
    status: "in-progress",
    thumbnail: "/images/thumbnails/brand-page-v3.png",
    creationTool: "claude-code",
  },
  {
    id: "brand-page-v4",
    name: "Brand Page V4",
    path: "/rl/brand-v4",
    description:
      "Production-matching logged-in brand page (P.F. Candle Co.): full-bleed cover, avatar + brand meta, Faire Market banner, Insider card, category tabs + filter pills, real 70-product grid, and reviews with brand replies. Iterates on V3; source for the bwp-playground BrandPageTemplate.",
    owner: "Ryan Lee",
    createdAt: "2026-07-01",
    lastUpdated: "2026-07-01",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "/images/thumbnails/brand-page-v4.png",
    creationTool: "claude-code",
  },
  {
    id: "pfcandle-home",
    name: "PF Candle Home",
    path: "/rl/pfcandle-home",
    // Flow: starts on the P.F. Candle Co. wholesale page (static), whose
    // "Browse our catalog on Faire" CTAs lead into the brand page at `path`.
    externalUrl: "/prototypes/pf-candle-co/pfcandle-wholesale.html",
    description:
      "Merchandised brand storefront 'Home' page for P.F. Candle Co. (Figma: Brand Wholesale Platform — Top 8): maroon brand hero, category tiles, Bestsellers + Collections carousels, promo banner, and Faire Market banner. Flow starts on the wholesale page.",
    owner: "Ryan Lee",
    createdAt: "2026-07-03",
    lastUpdated: "2026-07-16",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/ccbe66857b10590173096b1864fab2929160ff2a6c81fa04cdbdd9eda06f9914.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-suma-home",
    name: "Suma Collective Home",
    path: "/rl/suma-home",
    description:
      "Brand-page proposal on a fictional brand (Suma Collective) so it can be shared with real brands — a self-contained warm-desert home-goods storefront. Masthead / tab / brand-maturity / auth / name / promos / left-nav explorations via the LiveToolbar.",
    owner: "Ryan Lee",
    createdAt: "2026-07-21",
    lastUpdated: "2026-07-21",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/079f933c7d54d5de4d784d0a6f70cda3386c7e9039fa055c13d61fbad65ffe86.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-primitives-by-kathy-fd-home",
    name: "Primitives by Kathy — FD Home",
    path: "/rl/primitives-by-kathy-fd-home",
    description:
      "Faire Direct home / brand-page proposal for Primitives by Kathy — the wholesale storefront a retailer lands on from the brand's site. Re-skins the Suma proto in Primitives' identity (real logo, brick-red + dusty-teal script, real catalog & voice). Masthead / tab / brand-maturity / auth / name / promos / left-nav explorations via the LiveToolbar.",
    owner: "Ryan Lee",
    createdAt: "2026-07-22",
    lastUpdated: "2026-07-23",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/2eb944b7beb4bd797e86bf521541dd8b0f34ca8281f5b3c1de9b9ea33000bff6.png",
    creationTool: "claude-code",
  },
  {
    id: "pfcandle-brand-home-v3",
    name: "PF Candle Brand Home V3",
    path: "/rl/pfcandle-brand-home-v3",
    description:
      "The P.F. Candle Co. brand home on Faire — where retailers land after clicking in from the brand's own site. Leads with category tiles and a featured 'Tried & True Best Sellers' collection, then bestsellers, collections, videos, and reviews. Versions by auth (logged-in / logged-out with MSRP + 'Sign in for WSP') and source (arriving from Faire Direct vs. Marketplace).",
    owner: "Ryan Lee",
    createdAt: "2026-07-07",
    lastUpdated: "2026-08-18",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/36b080499c34920151dce77860147c0bb6232d3797b828e0cf1315e6c5eb17a3.png",
    creationTool: "claude-code",
  },
  {
    id: "pfcandle-fd",
    name: "PF Candle FD",
    path: "/rl/pfcandle-fd",
    // The prototype is a flow: it starts on the P.F. Candle Co. wholesale page
    // (static), whose "Browse our catalog on Faire" CTA leads into the brand
    // page at `path` (/rl/pfcandle-fd). The feed card opens the start page.
    externalUrl: "/prototypes/pf-candle-co/register-faire-v4.html",
    description:
      "Faire Direct storefront flow: starts on the P.F. Candle Co. wholesale page, then 'Browse our catalog on Faire' leads into the Faire-hosted brand page (copy of Brand Page V4, with a Layermor-style full-height left-panel variant).",
    owner: "Ryan Lee",
    createdAt: "2026-07-02",
    lastUpdated: "2026-07-07",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/cccac00c374eee76098777faa2301999bc2572c209981bf1ba45c9efdb04d7bd.png",
    creationTool: "claude-code",
  },
  {
    id: "brand-storefronts",
    name: "Brand Storefronts",
    path: "/rl/brand-storefronts",
    description:
      "Atlas (god-mode IA map) for branded storefront explorations. Press ⇧Z anywhere inside the umbrella to zoom out. Multiple flows across example brands (Layermor, OLIPOP, Ora Cacao) — each row is a brand's storefront flow from Shopify-style entry into the Faire-hosted brand page.",
    owner: "Ryan Lee",
    createdAt: "2026-04-21",
    lastUpdated: "2026-05-01",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/7511bc067958752bc74a3efaab5b99ad7c3656850a855b830066e8fd86a2c183.png",
    creationTool: "claude-code",
  },
  {
    id: "ideas-v1",
    name: "Ideas V1",
    path: "/rl/ideas-v1",
    description:
      "V1 exploration of Ideas — iterating toward a shippable ideas experience.",
    owner: "Ryan Lee",
    createdAt: "2026-04-14",
    lastUpdated: "2026-05-01",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "/images/thumbnails/ideas-v1.png",
    creationTool: "claude-code",
  },
  {
    id: "ideas-r3",
    name: "Ideas R3",
    path: "/rl/ideas-r3",
    description:
      "Ideas R3 prototype with layout variants, FOMO filtering, and processing animation.",
    owner: "Ryan Lee",
    createdAt: "2026-04-02",
    lastUpdated: "2026-05-01",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail: "/images/thumbnails/ideas-r3.png",
    creationTool: "cursor",
  },
  {
    id: "themes-r2-rl",
    name: "Themes R2 RL",
    path: "/rl/themes-r2-rl",
    description:
      "Clean duplicate of Themes prototype with DiscoveryProductTile and simplified detail page",
    owner: "Ryan Lee",
    createdAt: "2026-03-14",
    lastUpdated: "2026-03-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail: "/images/thumbnails/themes-r2-rl.png",
    creationTool: "cursor",
  },
  {
    id: "themes",
    name: "Themes",
    path: "/rl/themes",
    description:
      "Homepage layout with themed tile grid and collage-style tiles.",
    owner: "Ryan",
    createdAt: "2026-02-24",
    lastUpdated: "2026-05-01",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail: "/images/thumbnails/themes.png",
    creationTool: "claude-code",
  },
  {
    id: "pdp-refresh",
    name: "PDP Refresh",
    path: "/rl/pdp-refresh",
    description:
      "Refreshed product detail page: layout variants, reviews (filters, AI summary, histogram), and configurable PDP content. No Compass panel — see Compass Panel Explorations for panel work.",
    owner: "Ryan",
    createdAt: "2026-02-09",
    lastUpdated: "2026-08-29",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    project: "PDP Explorations",
    thumbnail: "/images/thumbnails/pdp-refresh.png",
    creationTool: "claude-code",
  },
  {
    id: "brand-cart-overlay-concept",
    name: "Brand cart overlay concept",
    path: "/rl/brand-cart-overlay-concept",
    description:
      "Brand cart pill concepts: morph-in-place overlay and dropdown-style overlay. Explores cart representation in the nav.",
    owner: "Ryan",
    createdAt: "2026-02-09",
    lastUpdated: "2026-05-01",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail: "/images/thumbnails/brand-cart-overlay-concept.png",
    creationTool: "cursor",
  },
  {
    id: "compass-chat-behavior",
    name: "Compass Chat Behavior",
    path: "/rl/compass-chat-behavior",
    description:
      "Blank surface with Global Nav and Compass Drawer Overlay. Explores chat behavior and interactions in a minimal context.",
    owner: "Ryan",
    createdAt: "2025-12-10",
    lastUpdated: "2025-12-16",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail: "/images/thumbnails/compass-chat-behavior.png",
    project: "Compass",
    creationTool: "cursor",
  },
  {
    id: "index-exploration",
    name: "Index Exploration — RL01",
    path: "/rl/index-exploration",
    description:
      "Exploring different iterations and variations of the index page design. Testing layouts, interactions, and navigation patterns.",
    owner: "Ryan",
    createdAt: "2025-12-10",
    lastUpdated: "2026-05-01",
    surfaceArea: "Other",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/dd4c6a00b12a42db4fe81687c3c4ebc296db2568ecfc3e2918f967007d58fe7d.png",
    project: "Index Exploration",
    creationTool: "cursor",
  },
  {
    id: "index-exploration-v2",
    name: "Index Exploration — RL02",
    path: "/rl/index-exploration-v2",
    description:
      "Two-column layout with left sidebar navigation and right content area. Exploring alternative index page structures.",
    owner: "Ryan",
    createdAt: "2025-12-15",
    lastUpdated: "2025-12-16",
    surfaceArea: "Other",
    category: "experimental",
    status: "legacy",
    thumbnail: "/images/thumbnails/index-exploration-v2.png",
    project: "Index Exploration",
    creationTool: "cursor",
  },
  {
    id: "pdp-with-drawer",
    name: "PDP with Drawer",
    path: "/rl/pdp-with-drawer",
    description:
      "Product detail page with Compass integration via side drawer. Explores how Compass could work within the product browsing experience.",
    owner: "Ryan",
    createdAt: "2025-11-20",
    lastUpdated: "2025-11-20",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail: "/images/thumbnails/pdp-with-drawer.png",
    project: "PDP Explorations",
    creationTool: "cursor",
  },
  {
    id: "pdp-with-drawer-left",
    name: "PDP with Drawer (Left)",
    path: "/rl/pdp-with-drawer-left",
    description:
      "Alternative PDP layout with Compass drawer opening from the left side. Tests different spatial arrangements for the Compass integration.",
    owner: "Ryan",
    createdAt: "2025-11-20",
    lastUpdated: "2025-11-20",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail: "/images/thumbnails/pdp-with-drawer-left.png",
    project: "PDP Explorations",
    creationTool: "cursor",
  },
  {
    id: "pdp-v2",
    name: "PDP v2",
    path: "/rl/pdp-v2",
    description:
      "Experimental variant of the product detail page. Explores alternative layouts and interaction patterns for product browsing.",
    owner: "Ryan",
    createdAt: "2025-11-15",
    lastUpdated: "2025-12-16",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail: "/images/thumbnails/pdp-v2.png",
    project: "PDP Explorations",
    creationTool: "cursor",
  },
  {
    id: "compass-contained",
    name: "🧭 Compass Ecosystem Approach",
    path: "/rl/compass-contained/home",
    description:
      "Isolated Compass flow starting with John's homepage prototype. Explores a contained ecosystem approach to Compass integration.",
    owner: "Ryan",
    createdAt: "2025-11-23",
    lastUpdated: "2025-11-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail: "/images/thumbnails/compass-contained.png",
    project: "Compass",
    creationTool: "cursor",
  },
  {
    id: "compass-drawer-overlay",
    name: "🧭 Compass Drawer Overlay",
    path: "/rl/compass-drawer-overlay-demo",
    description:
      "Compass drawer implemented as an overlay model. The drawer slides in from the side with a backdrop, sitting on top of content rather than being part of the grid layout.",
    owner: "Ryan",
    createdAt: "2025-12-03",
    lastUpdated: "2025-12-10",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail: "/images/thumbnails/compass-drawer-overlay.png",
    project: "Compass",
    creationTool: "cursor",
  },
  {
    id: "pdp-v2-with-ai",
    name: "PDP with AI overview",
    path: "/rl/pdp-v2-with-ai",
    description:
      "Product detail page with AI-powered overview and search. Features Compass drawer integration for product questions.",
    owner: "Ryan",
    createdAt: "2025-11-23",
    lastUpdated: "2025-11-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail: "/images/thumbnails/pdp-v2-with-ai.png",
    project: "PDP Explorations",
    creationTool: "cursor",
  },
  {
    id: "pdp-v2-with-ai-inline",
    name: "PDP with AI overview (inline)",
    path: "/rl/pdp-v2-with-ai-inline",
    description:
      "Product detail page with AI answers displayed inline in the Overview section. Alternative to drawer-based interaction.",
    owner: "Ryan",
    createdAt: "2025-11-23",
    lastUpdated: "2025-11-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail: "/images/thumbnails/pdp-v2-with-ai-inline.png",
    project: "PDP Explorations",
    creationTool: "cursor",
  },
  {
    id: "pdp-with-overlay-push",
    name: "PDP with Overlay Push Drawer",
    path: "/rl/pdp-with-overlay-push",
    description:
      "Product detail page with Compass drawer as an overlay that pushes grid content. Combines overlay styling with layout shifting.",
    owner: "Ryan",
    createdAt: "2025-12-03",
    lastUpdated: "2025-12-08",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail: "/images/thumbnails/pdp-with-overlay-push.png",
    project: "PDP Explorations",
    creationTool: "cursor",
  },
  {
    id: "brand-page-v2",
    name: "Brand Page V2 (with AI summary)",
    path: "/rl/brand/casa-bosques/v2",
    description:
      "Brand page variant with AI summary box and action buttons positioned on banner image.",
    owner: "Ryan",
    createdAt: "2025-11-23",
    lastUpdated: "2025-11-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/87ba8e15f864dda6fb9fcd62f1a6c3c30f5ad21f4f248a2cb48bfb1112b6093d.png",
    creationTool: "cursor",
  },
  {
    id: "basic-logged-in",
    name: "Basic Logged-in",
    path: "/rl/template",
    description:
      "Foundation template for logged-in retailer experience. Includes global navigation, search, and standard layout structure.",
    owner: "Ryan",
    createdAt: "2025-11-10",
    lastUpdated: "2025-11-09",
    surfaceArea: "Retailer",
    category: "template",
    status: "legacy",
    thumbnail: "/images/thumbnails/basic-logged-in.png",
    creationTool: "cursor",
  },
  {
    id: "new-page",
    name: "New Page",
    path: "/rl/new-page",
    description:
      "Blank template for starting new retailer pages. Provides the basic layout structure and navigation chrome.",
    owner: "Ryan",
    createdAt: "2025-11-10",
    lastUpdated: "2025-12-08",
    surfaceArea: "Retailer",
    category: "template",
    status: "legacy",
    thumbnail: "/images/thumbnails/new-page.png",
    creationTool: "cursor",
  },
  {
    id: "brand-page",
    name: "Brand Page",
    path: "/rl/brand",
    description:
      "Brand detail page template showing brand information, products, and filtering. Mirrors current production brand page layout.",
    owner: "Ryan",
    createdAt: "2025-11-10",
    lastUpdated: "2025-11-24",
    surfaceArea: "Retailer",
    category: "template",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/db893784be084722e1d5acd17e859d851ac21d0f3e356a96fb7e7f6f75804c89.png",
    creationTool: "cursor",
  },
  {
    id: "search-results",
    name: "Search Results",
    path: "/rl/search-results",
    description:
      "Search results page template with product grid, filters, and sorting. Reflects current production search experience.",
    owner: "Ryan",
    createdAt: "2025-11-10",
    lastUpdated: "2025-11-24",
    surfaceArea: "Retailer",
    category: "template",
    status: "legacy",
    thumbnail: "/images/thumbnails/search-results.png",
    creationTool: "cursor",
  },
  {
    id: "search-results-v2",
    name: "Search Results v2",
    path: "/rl/search-results-v2",
    description:
      "Updated search results page based on actual frontend implementation. Includes improved sticky filter row, header structure, and responsive grid layout.",
    owner: "Ryan",
    createdAt: "2025-12-11",
    lastUpdated: "2025-12-16",
    surfaceArea: "Retailer",
    category: "template",
    status: "legacy",
    thumbnail: "/images/thumbnails/search-results-v2.png",
    creationTool: "cursor",
  },
  {
    id: "pdp",
    name: "PDP",
    path: "/rl/pdp",
    description:
      "Standard product detail page template. Mirrors current production PDP with images, product info, pricing, and add to cart.",
    owner: "Ryan",
    createdAt: "2025-11-10",
    lastUpdated: "2025-11-18",
    surfaceArea: "Retailer",
    category: "template",
    status: "legacy",
    thumbnail: "/images/thumbnails/pdp.png",
    creationTool: "cursor",
  },
  {
    id: "checkout",
    name: "Checkout",
    path: "/rl/checkout",
    description:
      "Checkout flow template including cart review, shipping, and payment. Reflects current production checkout experience.",
    owner: "Ryan",
    createdAt: "2025-11-10",
    lastUpdated: "2025-11-09",
    surfaceArea: "Retailer",
    category: "template",
    status: "legacy",
    thumbnail: "/images/thumbnails/checkout.png",
    creationTool: "cursor",
  },
  {
    id: "order-confirmation",
    name: "Order Confirmation",
    path: "/rl/order-confirmation",
    description:
      "Post-purchase confirmation page template. Shows order summary, shipping details, and next steps.",
    owner: "Ryan",
    createdAt: "2025-11-10",
    lastUpdated: "2026-05-01",
    surfaceArea: "Retailer",
    category: "template",
    status: "legacy",
    thumbnail: "/images/thumbnails/order-confirmation.png",
    creationTool: "cursor",
  },
  {
    id: "category-page",
    name: "Category Page",
    path: "/rl/category/:categoryName",
    description:
      "Category browsing page template with product grid and category-specific filtering.",
    owner: "Ryan",
    createdAt: "2025-11-10",
    lastUpdated: "2025-11-21",
    surfaceArea: "Retailer",
    category: "template",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/1a596d4ec95b0744863ac70ed262d52e8ed5e0e6d7cedb98e111df3da9bf4d11.png",
    creationTool: "cursor",
  },
  {
    id: "new-retailer-page",
    name: "Compass Panel Explorations",
    path: "/rl/compasspanelexplorations",
    description:
      "Standalone prototype for Compass panel: panel behaviors, positioning variants, nav icon placement, floating icon, and left-side panel. PDP content lives in PDP Refresh prototype.",
    owner: "Ryan",
    createdAt: "2026-01-17",
    lastUpdated: "2026-01-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    project: "Compass panel explorations",
    thumbnail: "/images/thumbnails/new-retailer-page.png",
    creationTool: "cursor",
  },
  {
    id: "rl-faire-direct-signup-control",
    name: "Faire Direct Signup (Control)",
    path: "/rl/faire-direct-signup-control",
    description:
      "Retailer-facing heavy wholesale signup (control variant) — one B2B application, re-skinnable across Faire, E. Frances, Spongellé, and Post House looks via the toolbar. Powered by Faire Direct.",
    owner: "Ryan Lee",
    createdAt: "2026-06-03",
    lastUpdated: "2026-06-03",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "/images/thumbnails/rl-faire-direct-signup-control.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-faire-direct-brand-portal",
    name: "Faire Direct (Brand Portal)",
    path: "/rl/faire-direct-brand-portal",
    description:
      "Faithful rebuild of the brand-portal Faire Direct landing page in its first-run (not-yet-activated) state: hero, share link, order-taking tools, more tools, retailer benefits, FAQs, and more-help banner.",
    owner: "Ryan Lee",
    createdAt: "2026-06-03",
    lastUpdated: "2026-06-03",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/8bd7c1d37e40725465b6d541b2ada157516ae7580633748133e56ae038478bac.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-brand-page-lookbook",
    name: "Brand Page Lookbook",
    path: "/rl/brand-page-lookbook",
    description:
      "Brand storefront (v3 template) with a lookbook entry point modeled on the saved-boards image-peek button. Clicking it opens an Issuu-style flippable catalog reader (page-turn animation).",
    owner: "Ryan Lee",
    createdAt: "2026-06-19",
    lastUpdated: "2026-06-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/704ad0c51438e88ee1409a8909612d0db88b10a4e99768fe1d5685e478e64129.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-fd-commission-request",
    name: "FD Commission Request",
    path: "/rl/fd-commission-request",
    description:
      "Brand-side flow for requesting a commission adjustment in Faire Direct",
    owner: "Ryan Lee",
    createdAt: "2026-06-25",
    lastUpdated: "2026-06-26",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6c03d84ac973719f05addf90cbcb6af6a44f7a94b89448176ced21f06458c00e.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-brand-portal-nav-grid-explorations",
    name: "Brand Portal Nav and Grid Explorations",
    path: "/rl/brand-portal-nav-grid-explorations",
    description:
      "Explorations of the brand portal's left navigation and body-area grid — multiple switchable nav variations (icons, density, collapsible rail, grouping) building on the Faire Direct channel-reframe shell.",
    owner: "Ryan Lee",
    createdAt: "2026-07-07",
    lastUpdated: "2026-07-21",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-brand-portal-nav-grid-explorations.png",
    creationTool: "claude-code",
  },
  {
    id: "pfcandle-wholesale-login-v3",
    name: "PF Candle Wholesale Login V3",
    path: "/rl/pfcandle-wholesale-login-v3",
    description:
      "P.F. Candle Co.'s own website (brand.com): the brand's 'Order on Faire' wholesale-login / channel-router page at the top, then a brand-forward storefront below it — Bestsellers, a featured collection, videos, and reviews — showing MSRP + 'Sign in for WSP', not fully shoppable, with everything routing into Faire.",
    owner: "Ryan Lee",
    createdAt: "2026-08-03",
    lastUpdated: "2026-08-12",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/a78a515cea3954c39146adecf58cd06d35058d4046991dcc5b250b4494427c6c.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-beefys-own-home",
    name: "Beefy's Own Home",
    path: "/rl/beefys-own-home",
    description:
      "Thin-catalog brand home: 5 SKUs carried by brand-curated featured reviews, in 3 form factors",
    owner: "Ryan Lee",
    createdAt: "2026-08-16",
    lastUpdated: "2026-08-18",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-beefys-own-home.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-sweet-wink-home",
    name: "Sweet Wink Home",
    path: "/rl/sweet-wink-home",
    description:
      "Brand-home framework proof-of-concept: Sweet Wink piped in via BrandDataset (brand #1 of 3)",
    owner: "Ryan Lee",
    createdAt: "2026-08-11",
    lastUpdated: "2026-08-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-sweet-wink-home.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-le-lis-home",
    name: "Le Lis Home",
    path: "/rl/le-lis-home",
    description:
      "Brand-home framework proof-of-concept: Le Lis piped in via BrandDataset (brand #2 of 3)",
    owner: "Ryan Lee",
    createdAt: "2026-08-11",
    lastUpdated: "2026-08-18",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-le-lis-home.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-ora-cacao-home",
    name: "Ora Cacao Home",
    path: "/rl/ora-cacao-home",
    description:
      "Brand-home framework proof-of-concept: Ora Cacao piped in via BrandDataset (brand #4)",
    owner: "Ryan Lee",
    createdAt: "2026-08-11",
    lastUpdated: "2026-08-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-ora-cacao-home.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-noble-micks-home",
    name: "Noble Micks Home",
    path: "/rl/noble-micks-home",
    description:
      "Brand-home framework proof-of-concept: Noble Micks piped in via BrandDataset (brand #5)",
    owner: "Ryan Lee",
    createdAt: "2026-08-11",
    lastUpdated: "2026-08-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-noble-micks-home.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-lemonade-shoes-home",
    name: "Lemonade Shoes Home",
    path: "/rl/lemonade-shoes-home",
    description:
      "Brand-home framework proof-of-concept: Lemonade Shoes piped in via BrandDataset (brand #6)",
    owner: "Ryan Lee",
    createdAt: "2026-08-13",
    lastUpdated: "2026-08-18",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-lemonade-shoes-home.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-viverano-organics-home",
    name: "Viverano Organics Home",
    path: "/rl/viverano-organics-home",
    description:
      "Brand-home framework proof-of-concept: Viverano Organics piped in via BrandDataset",
    owner: "Ryan Lee",
    createdAt: "2026-08-11",
    lastUpdated: "2026-08-18",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-viverano-organics-home.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-pfcandle-wholesale",
    name: "P.F. Candle Co. Wholesale (brand site)",
    path: "/rl/pfcandle-wholesale",
    description:
      "P.F. Candle Co.'s own site \u2014 their real global nav, typography and footer \u2014 with a Faire-exclusive wholesale page between them: single-channel router, best sellers, collections and a rotating stockist review. Faire CTAs lead into the P.F. Candle Faire brand home, so the brand site and the Faire surface read as one flow.",
    owner: "Ryan Lee",
    createdAt: "2026-08-17",
    lastUpdated: "2026-08-18",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-pfcandle-wholesale.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-viverano-wholesale",
    name: "Viverano Wholesale (brand site)",
    path: "/rl/viverano-wholesale",
    description:
      "Viverano Organics' own wholesale-info page with a two-channel router (Order on Faire / Order direct) replacing their account CTA. Faire CTAs lead into the Viverano Organics Faire brand home, so the brand site and the Faire surface read as one flow.",
    owner: "Ryan Lee",
    createdAt: "2026-08-14",
    lastUpdated: "2026-08-18",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-viverano-wholesale.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-lelis-wholesale",
    name: "Le Lis Wholesale (brand site)",
    path: "/rl/lelis-wholesale",
    description:
      'Le Lis\' wholesale-only storefront at the moment a retailer chooses an account: their "Login or create an account" page, replaced with a two-channel router (Order on Faire / Order direct). Faire CTAs lead into the Le Lis Faire brand home, so the brand site and the Faire surface read as one flow.',
    owner: "Ryan Lee",
    createdAt: "2026-08-14",
    lastUpdated: "2026-08-18",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-lelis-wholesale.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-brand-home-header-v1",
    name: "Brand Home Header V1",
    path: "/rl/brand-home-header-v1",
    description:
      "Canonical v1 of the brand home header, hosted on the Faire Direct landing page (a logged-out brand page). One frozen treatment for Discovery sign-off, built to be forked for Retailer Growth and Faire Direct tests.",
    owner: "Ryan Lee",
    createdAt: "2026-08-29",
    lastUpdated: "2026-08-29",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/rl-brand-home-header-v1.png",
    creationTool: "claude-code",
  },
  {
    id: "rl-playground-demo-reel",
    name: "Playground Demo Reel",
    path: "/rl/playground-demo-reel",
    description: "",
    owner: "Ryan Lee",
    createdAt: "2026-08-30",
    lastUpdated: "2026-08-30",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail: "/images/thumbnails/rl-playground-demo-reel.png",
  },
  {
    id: "rl-kendrick-home",
    name: "Kendrick Home — Brand Home",
    path: "/rl/kendrick-home",
    // Flow: starts on their full-page brand.com storefront (the Website Builder
    // generated homepage). "Start shopping" leads into the Faire Direct brand
    // page at `path` — cream color block, illustrated wordmark, catalog.
    externalUrl:
      "/static-prototypes/website-builder-framework/preview.html?brand=kendrick-home&role=homepage",
    description:
      "Kendrick Home's Faire Direct brand page — cream color block and their illustrated wordmark — reached from the full-page storefront on brand.com.",
    owner: "Ryan Lee",
    createdAt: "2026-09-28",
    lastUpdated: "2026-09-28",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/rl-kendrick-home.png",
  },
  {
    id: "rl-softies-home",
    name: "Softies Brand Home",
    path: "/rl/softies-home",
    // Flow: starts on the Softies wholesale page, whose "Start Shopping" CTAs lead into the
    // brand home at `path`. The copied page keeps its rehosted fonts and Faire catalog imagery
    // in the adjacent assets folder so the brand.com surface stays faithful off-domain.
    // Source of truth for that page is Faire/bwp-playground
    // (public/prototypes/softies-pjs/wholesale.build.mjs); it emits this copy — re-copy it rather
    // than hand-editing this file. This is that script's `v2.html` output (its mirrored hero:
    // panel left, photo right), not its `index.html`, so re-copy from v2 to stay in sync.
    externalUrl: "/static-prototypes/rl-softies-wholesale/index.html",
    description:
      "Softies' Faire brand Home tab, built from their real catalog, ratings and collections — the brand-home framework pointed at b_br6ji29u.",
    owner: "Ryan Lee",
    createdAt: "2026-09-02",
    lastUpdated: "2026-09-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail: "/images/thumbnails/rl-softies-home.png",
  },
  {
    id: "rl-faire-direct-landing-page-v0",
    name: "Faire Direct Landing Page v1",
    path: "/rl/faire-direct-landing-page-v0",
    description:
      "Faire Direct landing page spec, starting from Softies: Neutral 100 color block, sans-serif name, 5-up product grid.",
    owner: "Ryan Lee",
    createdAt: "2026-09-22",
    lastUpdated: "2026-09-22",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/rl-faire-direct-landing-page-v0.png",
  },
  {
    id: "rl-gumball-poodle-fd-landing",
    name: "Gumball Poodle Faire Direct Landing Page",
    path: "/rl/gumball-poodle-fd-landing",
    description:
      "The Faire Direct landing page piped with Gumball Poodle's real brand data: wordmark, banner, published collections, reviews and video.",
    owner: "Ryan Lee",
    createdAt: "2026-10-11",
    lastUpdated: "2026-10-11",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/af7282d3423ce6f07c61b482912c278ee182d07e312dad3ee79b773993b127e6.png",
  },
  {
    id: "rl-brand-page-header-sequencing",
    name: "Brand Page Header Sequencing",
    path: "/rl/brand-page-header-sequencing",
    description:
      "Review cut of the Faire Direct landing page: V0 (Neutral 100, sans name) vs V1 (brand color + wordmark). Extra knobs stay on Faire Direct Landing Page v0.",
    owner: "Ryan Lee",
    createdAt: "2026-09-29",
    lastUpdated: "2026-09-29",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/rl-faire-direct-landing-page-v0.png",
  },
  {
    id: "rl-vanilla-website-configurator",
    name: "Vanilla Website Configurator",
    path: "/rl/vanilla-website-configurator/website",
    description:
      "A ready-to-share Faire-hosted wholesale storefront for brands without a usable website preview.",
    owner: "Ryan Lee",
    createdAt: "2026-10-12",
    lastUpdated: "2026-10-12",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/rl-vanilla-website-configurator.png",
  },
];
